<template>
  <div class="pop pop-check">
    <div class="popin" @click="$event.stopPropagation()">
      <!-- 팝업 닫을 때 아래 alert 박스를 띄워주시고 천천히 사라지게 해주세요. 현재 화면에 그냥 보이게 해두었어요. -->
      <div class="btn-close" @click="emits('close')">
        <span class="blind">Close</span>
      </div>
      <div class="pop-title">
        <h3 class="title">
          {{ $t('실천한항목에체크하세요') }}
        </h3>
        <div class="today">
          <div class="date">
            {{ formattedDate }}
          </div>
        </div>
      </div>
      <div class="pop-con">
        <CheckList :checked-items="checkedItems" :date="date" @on-item-click="onItemClick" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  date: Date
}>()

const emits = defineEmits<{
  (event: 'close'): void
  (event: 'onItemClick', campaignItemId: number, date: Date, callback?: () => Promise<void>): void
}>()

useHead({
  bodyAttrs: {
    class: 'lock',
  },
})

const { fetchMyCheckedItems } = useChecklist()
const checkedItems = ref<Record<number, boolean>>({})

await loadCheckedItems()

async function loadCheckedItems() {
  checkedItems.value = await fetchMyCheckedItems({
    date: props.date,
  })
}

const { locale } = useI18n()

const formattedDate = computed(() => {
  return formatIntlDate(props.date, locale.value)
})

async function onItemClick(campaignItemId: number) {
  emits('onItemClick', campaignItemId, props.date, async () => {
    await loadCheckedItems()
  })
}
</script>
